import {StateProvider} from "@uirouter/angularjs";
import {FeatureNames, UserConfigProvider} from "../types/UserConfig";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {

    if (userConfigProvider.config.features[FeatureNames.SCREEN_ACCOUNT_LIST]) {
        $stateProvider.state("adviser", {
            url: "/adviser",
            templateUrl: "app/adviser/adviser.tpl.html",
            controller: "adviserCtrl as adviser",
            data: {
                pageTitle: "Adviser"
            }
        });
    }
}
